var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"mode":"out-in"}},[(_vm.$auth.ready())?_c('div',[_c('router-view',{key:_vm.$route.path})],1):_vm._e()]),_vm._v(" "),(!_vm.$auth.ready())?_c('div',[_vm._v("\n    Loading ...\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8c1ceb","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 169
// module chunks = 1